// Representantes Page JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Get real data from the database via vendedores variable
    let stores = [];
    let currentDisplayedStores = []; // Keep track of currently displayed stores
    
    try {
        if (typeof vendedores !== 'undefined' && vendedores.length > 0) {
            stores = [];
            
            vendedores.forEach(rep => {
                // Processar os estados - pode ser string ou array
                let states = [];
                if (typeof rep.state === 'string') {
                    // Se for string, tentar fazer parse se for JSON ou usar como array simples
                    try {
                        states = JSON.parse(rep.state);
                        if (!Array.isArray(states)) {
                            states = [rep.state];
                        }
                    } catch (e) {
                        states = [rep.state];
                    }
                } else if (Array.isArray(rep.state)) {
                    states = rep.state;
                } else {
                    states = ['Localização não informada'];
                }

                // Criar um store para cada estado
                states.forEach(state => {
                    stores.push({
                        title: rep.name || 'Representante',
                        address: `${state}`,
                        lat: parseFloat(rep.lat) || null,
                        lng: parseFloat(rep.lng) || null,
                        city: state, // Usar o estado como cidade
                        state: state,
                        phone: rep.phones || '',
                        email: rep.email || '',
                        wpp: rep.whatsapp || '',
                        distance: null, // Will be calculated dynamically from map center
                        link: rep.contact || 'https://rodotecnica.com.br/contato',
                        needsGeocoding: !rep.lat || !rep.lng, // Flag para indicar se precisa de geocoding
                        originalRep: rep // Referência ao representante original
                    });
                });
            });
        }
    } catch (error) {
        console.error('Error processing representatives data:', error);
        // Fallback to default data if processing fails
        stores = [
            {
                title: "RodoTécnica",
                address: "São Paulo - SP",
                lat: -23.561684,
                lng: -46.655981,
                city: "São Paulo - SP",
                state: "São Paulo",
                phone: "(54) 3458 3600",
                email: "rodotecnica@rodotecnica.com.br",
                wpp: "545434583600",
                distance: null, // Will be calculated dynamically from map center
                link: "https://rodotecnica.com.br/contato",
                needsGeocoding: false
            }
        ];
    }

    // Helper: build unique representatives from stores (no duplicates in sidebar)
    function getRepresentatives() {
        const repKeyToRep = new Map();
        stores.forEach(store => {
            const rep = store.originalRep || {};
            const key = `${rep.name || store.title}__${rep.email || ''}`.toLowerCase();

            if (!repKeyToRep.has(key)) {
                repKeyToRep.set(key, {
                    title: rep.name || store.title || 'Representante',
                    phone: rep.phones || store.phone || '',
                    email: rep.email || store.email || '',
                    wpp: rep.whatsapp || store.wpp || '',
                    link: rep.contact || store.link || 'https://rodotecnica.com.br/contato',
                    states: new Set(),
                    // Keep first available coordinates just for centering when clicking a card
                    lat: rep.lat || store.lat || null,
                    lng: rep.lng || store.lng || null
                });
            }

            const acc = repKeyToRep.get(key);
            if (store.state) acc.states.add(store.state);
            if ((store.lat && store.lng) && (acc.lat == null || acc.lng == null)) {
                acc.lat = store.lat;
                acc.lng = store.lng;
            }
        });

        // Normalize states from Set to Array and prepare display text
        return Array.from(repKeyToRep.values()).map(r => ({
            ...r,
            states: Array.from(r.states)
        }));
    }

    // Initialize the page
    initPage();

    async function initPage() {
        const loading = document.querySelector('.loading');
        
        loading.classList.remove('loaded');

        try {
            await processGeocoding();

            populateCards();
            setTimeout(initMap, 100);
            initSearch();
        } catch (error) {
            console.error('Erro ao inicializar:', error);
        } finally {
            loading.classList.add('loaded');
        }
    }

    // helper de delay
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // Process geocoding for stores that need it (com pausa)
    async function processGeocoding() {
        for (const store of stores) {
            if (store.needsGeocoding && store.state) {
                try {
                    if (!store.lat || !store.lng) {
                        const coords = await geocodeCity(store.state);

                        if (coords) {
                            store.lat = coords.lat;
                            store.lng = coords.lng;
                            store.needsGeocoding = false;
                        }
                    }

                    await sleep(300);

                } catch (error) {
                    console.error(`Failed to geocode ${store.state}:`, error);
                }
            }
        }

        // Recarregar o mapa após o geocoding
        if (!window.map) {
            setTimeout(initMap, 100);
        } else {
            addNewMarkersToMap();
        }
    }


    // Geocode a state name to capital coordinates using Nominatim API
    async function geocodeCity(stateName) {
        try {
            // Mapear estados para suas capitais
            const stateCapitals = {
                'Acre': 'Rio Branco',
                'Alagoas': 'Maceió',
                'Amapá': 'Macapá',
                'Amazonas': 'Manaus',
                'Bahia': 'Salvador',
                'Ceará': 'Fortaleza',
                'Distrito Federal': 'Brasília',
                'Espírito Santo': 'Vitória',
                'Goiás': 'Goiânia',
                'Maranhão': 'São Luís',
                'Mato Grosso': 'Cuiabá',
                'Mato Grosso do Sul': 'Campo Grande',
                'Minas Gerais': 'Belo Horizonte',
                'Pará': 'Belém',
                'Paraíba': 'João Pessoa',
                'Paraná': 'Curitiba',
                'Pernambuco': 'Recife',
                'Piauí': 'Teresina',
                'Rio de Janeiro': 'Rio de Janeiro',
                'Rio Grande do Norte': 'Natal',
                'Rio Grande do Sul': 'Porto Alegre',
                'Rondônia': 'Porto Velho',
                'Roraima': 'Boa Vista',
                'Santa Catarina': 'Florianópolis',
                'São Paulo': 'São Paulo',
                'Sergipe': 'Aracaju',
                'Tocantins': 'Palmas'
            };

            // Buscar a capital do estado
            const capital = stateCapitals[stateName] || stateName;
            
            const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(capital + ', ' + stateName + ', Brasil')}&limit=1&addressdetails=1`
            );
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data && data.length > 0) {
                return {
                    lat: parseFloat(data[0].lat),
                    lng: parseFloat(data[0].lon)
                };
            }
            
            return null;
        } catch (error) {
            console.error('Geocoding error for state:', stateName, error);
            return null;
        }
    }

    // Add new markers to existing map
    function addNewMarkersToMap() {
        if (!window.map) return;
        
        // Try to get the icon URL from the hidden input, otherwise use inline SVG
        let iconUrl = document.getElementById('map-icon')?.value;

        if (!iconUrl) {
            // Fallback to inline SVG data URL
            const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="77" height="77" viewBox="0 0 77 77" fill="none">
                <g clip-path="url(#clip0_236_4350)">
                <path d="M58.9178 55.7096L38.5 76.1274L18.0822 55.7096C14.044 51.6713 11.2939 46.5263 10.1798 40.9251C9.06569 35.3239 9.63753 29.5181 11.823 24.2419C14.0085 18.9657 17.7095 14.4561 22.458 11.2833C27.2064 8.11047 32.7891 6.41699 38.5 6.41699C44.2109 6.41699 49.7936 8.11047 54.5421 11.2833C59.2905 14.4561 62.9915 18.9657 65.177 24.2419C67.3625 29.5181 67.9343 35.3239 66.8202 40.9251C65.7061 46.5263 62.956 51.6713 58.9178 55.7096V55.7096ZM38.5 48.1251C41.9036 48.1251 45.1678 46.773 47.5745 44.3663C49.9813 41.9596 51.3333 38.6954 51.3333 35.2917C51.3333 31.8881 49.9813 28.6239 47.5745 26.2172C45.1678 23.8105 41.9036 22.4584 38.5 22.4584C35.0964 22.4584 31.8322 23.8105 29.4255 26.2172C27.0188 28.6239 25.6667 31.8881 25.6667 35.2917C25.6667 38.6954 27.0188 41.9596 29.4255 44.3663C31.8322 46.773 35.0964 48.1251 38.5 48.1251V48.1251ZM38.5 41.7084C36.7982 41.7084 35.1661 41.0324 33.9627 39.829C32.7594 38.6257 32.0833 36.9935 32.0833 35.2917C32.0833 33.5899 32.7594 31.9578 33.9627 30.7545C35.1661 29.5511 36.7982 28.8751 38.5 28.8751C40.2018 28.8751 41.8339 29.5511 43.0373 30.7545C44.2406 31.9578 44.9167 33.5899 44.9167 35.2917C44.9167 36.9935 44.2406 38.6257 43.0373 39.829C41.8339 41.0324 40.2018 41.7084 38.5 41.7084Z" fill="#333333"/>
                </g>
                <path d="M51.7051 45.7259C53.7718 43.0302 55 39.6577 55 35.9984C55 27.8846 48.9617 21.1813 41.1342 20.1379C40.5476 32.0292 42.5445 45.3223 51.7051 45.7259Z" fill="#1DABE3"/>
                <path d="M36.8658 20.1379C29.0383 21.1813 23 27.8846 23 35.9984C23 39.4773 24.1101 42.6969 25.9953 45.3223C36.4846 46.5455 37.5772 26.6745 36.8658 20.1379Z" fill="#1DABE3"/>
                <path d="M38.7005 20.0014C37.9769 20.0014 37.564 20.0448 36.8658 20.1379C37.5772 26.6745 36.4846 46.5455 25.9953 45.3223C28.0611 48.1991 31.0578 50.3624 34.5445 51.3714C39 48.0058 38.7005 20.0014 38.7005 20.0014Z" fill="#333333"/>
                <path d="M39.2371 20.0014C39 37.3464 40.6474 49.1916 43.4555 51.3714C46.7772 50.4101 49.6541 48.4013 51.7051 45.7259C42.5445 45.3223 40.5476 32.0292 41.1342 20.1379C40.5608 20.0614 39.828 20.0154 39.2371 20.0014Z" fill="#333333"/>
                <path d="M34.5445 51.3714C35.9588 51.7807 37.4538 52 39 52C40.5462 52 42.0412 51.7807 43.4555 51.3714C40.6474 49.1916 39 37.3464 39.2371 20.0014C39.1473 19.9992 38.984 20.0001 38.8497 20.0008L38.8488 20.0008L38.8486 20.0008L38.848 20.0008L38.8462 20.0008C38.7898 20.0011 38.7386 20.0014 38.7005 20.0014C38.7005 20.0014 39 48.0058 34.5445 51.3714Z" fill="white"/>
                <defs>
                <clipPath id="clip0_236_4350">
                <rect width="77" height="77" fill="white"/>
                </clipPath>
                </defs>
                </svg>`;
            iconUrl = 'data:image/svg+xml;base64,' + btoa(svgContent);
        }

        const myIcon = L.icon({
            iconUrl: iconUrl,
            iconSize: [77, 77],
            iconAnchor: [38, 77],
            popupAnchor: [0, -80]
        });

        // Add markers for stores that were geocoded
        stores.forEach((store, idx) => {
            if (store.lat && store.lng && !store.needsGeocoding) {
                // Check if marker already exists
                const existingMarker = window.markers.find(marker => 
                    marker.getLatLng().lat === store.lat && marker.getLatLng().lng === store.lng
                );
                
                if (!existingMarker) {
                    const marker = L.marker([store.lat, store.lng], { icon: myIcon }).addTo(window.map);

                    const popupContent = `
                        <div style="min-width: 200px;">
                            <h4 style="margin: 0 0 10px 0; color: #09A7DA; font-size: 16px;">${store.title}</h4>
                            <p style="margin: 0 0 10px 0; font-size: 14px;">${store.state}</p>
                            <a href="https://www.google.com/maps?q=${encodeURIComponent(store.state)}"
                               target="_blank"
                               style="color: #09A7DA; text-decoration: none; font-size: 14px;">
                                Ver no Google Maps
                            </a>
                        </div>
                    `;

                    marker.bindPopup(popupContent);
                    window.markers.push(marker);
                }
            }
        });
    }

    // Initialize search functionality
    function initSearch() {
        const searchBtn = document.getElementById('search-btn');
        const locationInput = document.getElementById('location-input');

        if (searchBtn && locationInput) {
            // Search button click handler
            searchBtn.addEventListener('click', function() {
                const location = locationInput.value.trim();
                if (location) {
                    performSearch(location);
                } else {
                    // If no location entered, show all stores
                    showAllStores();
                }
            });

            // Enter key handler for input
            locationInput.addEventListener('keypress', function(e) {
                if (e.key === 'Enter') {
                    const location = locationInput.value.trim();
                    if (location) {
                        performSearch(location);
                    } else {
                        showAllStores();
                    }
                }
            });

            // Clear search functionality
            locationInput.addEventListener('input', function() {
                if (this.value.trim() === '') {
                    showAllStores();
                }
            });
        }
    }

    // Perform search based on location (over representatives' states)
    function performSearch(location) {
        const reps = getRepresentatives();
        const searchTerm = location.toLowerCase().trim();
        const filteredReps = reps.filter(rep =>
            rep.states.some(st => (st || '').toLowerCase().includes(searchTerm))
        );

        if (filteredReps.length > 0) {
            const sorted = filteredReps.sort((a, b) => a.title.localeCompare(b.title, 'pt-BR'));
            currentDisplayedStores = sorted;
            updateStoresDisplay(sorted);
            if (window.map && sorted[0] && sorted[0].lat != null && sorted[0].lng != null) {
                window.map.setView([sorted[0].lat, sorted[0].lng], 14);
            }
        } else {
            currentDisplayedStores = [];
            showNoResults();
        }
    }

    // Show all representatives (no duplicates)
    function showAllStores() {
        const reps = getRepresentatives();
        const sortedReps = reps.sort((a, b) => a.title.localeCompare(b.title, 'pt-BR'));
        currentDisplayedStores = sortedReps;
        updateStoresDisplay(sortedReps);
        // Reset map view to show all markers with padding
        if (window.map && stores.length > 0) {
            const validStores = stores.filter(store => store.lat && store.lng && !store.needsGeocoding);
            if (validStores.length > 0) {
                const bounds = L.latLngBounds(validStores.map(store => [store.lat, store.lng]));
                window.map.fitBounds(bounds, { padding: [20, 20] });
            }
        }
    }

    // Update representatives display (cards without duplicates)
    function updateStoresDisplay(repsToShow) {
        currentDisplayedStores = repsToShow;

        const cardsContainer = document.getElementById('cards-row');
        const template = document.getElementById('store-card-template');

        if (!cardsContainer || !template) return;

        cardsContainer.innerHTML = '';

        repsToShow.forEach((rep, index) => {
            const card = template.content.cloneNode(true);
            const cardElement = card.querySelector('[storeCard]');

            // Set data attributes
            cardElement.setAttribute('data-title', rep.title);
            cardElement.setAttribute('data-lat', rep.lat || '');
            cardElement.setAttribute('data-lng', rep.lng || '');
            cardElement.setAttribute('data-address', (rep.states || []).join(', '));
            cardElement.setAttribute('data-link', rep.link || '');

            // Set active state for first card
            if (index === 0) {
                cardElement.querySelector('.item').classList.add('active');
            }

            // Populate card content
            populateCardContent(card, {
                title: rep.title,
                phone: rep.phone,
                wpp: rep.wpp,
                email: rep.email,
                link: rep.link,
                // For textual display of coverage if the template includes it
                address: (rep.states || []).join(', ')
            }, index);
            cardsContainer.appendChild(card);
        });
    }

    // Show no results message
    function showNoResults() {
        currentDisplayedStores = []; // Clear displayed stores
        const cardsContainer = document.getElementById('cards-row');
        if (cardsContainer) {
            cardsContainer.innerHTML = `
                <div class="no-results">
                    <p>Nenhum representante encontrado para esta localização.</p>
                    <p>Tente uma busca diferente ou entre em contato conosco.</p>
                </div>
            `;
        }
    }

    // Populate store cards (using unique representatives)
    function populateCards() {
        const reps = getRepresentatives();
        const sortedReps = reps.sort((a, b) => a.title.localeCompare(b.title, 'pt-BR'));
        currentDisplayedStores = sortedReps;
        updateStoresDisplay(sortedReps);
    }

    // Populate individual card content
    function populateCardContent(card, store, index) {
        const titleElement = card.querySelector('[data-store-title]');
        if (titleElement) {
            titleElement.textContent = store.title;
        }

        // Phone
        if (store.phone) {
            const phoneContainer = card.querySelector('.phone-container');
            const phoneLink = card.querySelector('[data-store-phone]');
            if (phoneContainer && phoneLink) {
                phoneContainer.style.display = 'flex';
                phoneLink.href = `tel:${store.phone.replace(/\W/g, '')}`;
                phoneLink.textContent = store.phone;
            }
        }

        // WhatsApp
        if (store.wpp) {
            const whatsappContainer = card.querySelector('.whatsapp-container');
            const whatsappLink = card.querySelector('[data-store-whatsapp]');
            if (whatsappContainer && whatsappLink) {
                whatsappContainer.style.display = 'flex';
                whatsappLink.href = `https://wa.me/${store.wpp.replace(/\W/g, '')}`;
                whatsappLink.textContent = store.wpp;
            }
        }

        // Email
        if (store.email) {
            const emailContainer = card.querySelector('.email-container');
            const emailLink = card.querySelector('[data-store-email]');
            if (emailContainer && emailLink) {
                emailContainer.style.display = 'flex';
                emailLink.href = `mailto:${store.email}`;
                emailLink.textContent = store.email;
            }
        }

        // Distance - always show since it's calculated from map center
        if (store.distance) {
            const distanceContainer = card.querySelector('.distance-container');
            const distanceText = card.querySelector('[data-store-distance]');
            if (distanceContainer && distanceText) {
                distanceContainer.style.display = 'flex';
                distanceText.textContent = store.distance;
            }
        }

        // Contact link
        if (store.link) {
            const linkElement = card.querySelector('[data-store-link]');
            if (linkElement) {
                linkElement.href = store.link || '#';
            }
        }
    }

    // Initialize map
    function initMap() {
        const mapElement = document.getElementById('mapa');
        if (!mapElement) {
            console.error('Map element not found');
            return;
        }

        // Try to get the icon URL from the hidden input, otherwise use inline SVG
        let iconUrl = document.getElementById('map-icon')?.value;

        if (!iconUrl) {
            // Fallback to inline SVG data URL
            const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" width="77" height="77" viewBox="0 0 77 77" fill="none">
                <g clip-path="url(#clip0_236_4350)">
                <path d="M58.9178 55.7096L38.5 76.1274L18.0822 55.7096C14.044 51.6713 11.2939 46.5263 10.1798 40.9251C9.06569 35.3239 9.63753 29.5181 11.823 24.2419C14.0085 18.9657 17.7095 14.4561 22.458 11.2833C27.2064 8.11047 32.7891 6.41699 38.5 6.41699C44.2109 6.41699 49.7936 8.11047 54.5421 11.2833C59.2905 14.4561 62.9915 18.9657 65.177 24.2419C67.3625 29.5181 67.9343 35.3239 66.8202 40.9251C65.7061 46.5263 62.956 51.6713 58.9178 55.7096V55.7096ZM38.5 48.1251C41.9036 48.1251 45.1678 46.773 47.5745 44.3663C49.9813 41.9596 51.3333 38.6954 51.3333 35.2917C51.3333 31.8881 49.9813 28.6239 47.5745 26.2172C45.1678 23.8105 41.9036 22.4584 38.5 22.4584C35.0964 22.4584 31.8322 23.8105 29.4255 26.2172C27.0188 28.6239 25.6667 31.8881 25.6667 35.2917C25.6667 38.6954 27.0188 41.9596 29.4255 44.3663C31.8322 46.773 35.0964 48.1251 38.5 48.1251V48.1251ZM38.5 41.7084C36.7982 41.7084 35.1661 41.0324 33.9627 39.829C32.7594 38.6257 32.0833 36.9935 32.0833 35.2917C32.0833 33.5899 32.7594 31.9578 33.9627 30.7545C35.1661 29.5511 36.7982 28.8751 38.5 28.8751C40.2018 28.8751 41.8339 29.5511 43.0373 30.7545C44.2406 31.9578 44.9167 33.5899 44.9167 35.2917C44.9167 36.9935 44.2406 38.6257 43.0373 39.829C41.8339 41.0324 40.2018 41.7084 38.5 41.7084Z" fill="#333333"/>
                </g>
                <path d="M51.7051 45.7259C53.7718 43.0302 55 39.6577 55 35.9984C55 27.8846 48.9617 21.1813 41.1342 20.1379C40.5476 32.0292 42.5445 45.3223 51.7051 45.7259Z" fill="#1DABE3"/>
                <path d="M36.8658 20.1379C29.0383 21.1813 23 27.8846 23 35.9984C23 39.4773 24.1101 42.6969 25.9953 45.3223C36.4846 46.5455 37.5772 26.6745 36.8658 20.1379Z" fill="#1DABE3"/>
                <path d="M38.7005 20.0014C37.9769 20.0014 37.564 20.0448 36.8658 20.1379C37.5772 26.6745 36.4846 46.5455 25.9953 45.3223C28.0611 48.1991 31.0578 50.3624 34.5445 51.3714C39 48.0058 38.7005 20.0014 38.7005 20.0014Z" fill="#333333"/>
                <path d="M39.2371 20.0014C39 37.3464 40.6474 49.1916 43.4555 51.3714C46.7772 50.4101 49.6541 48.4013 51.7051 45.7259C42.5445 45.3223 40.5476 32.0292 41.1342 20.1379C40.5608 20.0614 39.828 20.0154 39.2371 20.0014Z" fill="#333333"/>
                <path d="M34.5445 51.3714C35.9588 51.7807 37.4538 52 39 52C40.5462 52 42.0412 51.7807 43.4555 51.3714C40.6474 49.1916 39 37.3464 39.2371 20.0014C39.1473 19.9992 38.984 20.0001 38.8497 20.0008L38.8488 20.0008L38.8486 20.0008L38.848 20.0008L38.8462 20.0008C38.7898 20.0011 38.7386 20.0014 38.7005 20.0014C38.7005 20.0014 39 48.0058 34.5445 51.3714Z" fill="white"/>
                <defs>
                <clipPath id="clip0_236_4350">
                <rect width="77" height="77" fill="white"/>
                </clipPath>
                </defs>
                </svg>`;
            iconUrl = 'data:image/svg+xml;base64,' + btoa(svgContent);
        }

        const myIcon = L.icon({
            iconUrl: iconUrl,
            iconSize: [77, 77],
            iconAnchor: [38, 77],
            popupAnchor: [0, -80]
        });

        // Center on Brazil's geographic center for initial view
        const center = [-14.2350, -51.9253]; // Centro geográfico do Brasil

        window.map = L.map('mapa').setView(center, 4);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 16
        }).addTo(window.map);

        // Add markers
        window.markers = [];
        stores.forEach((store, idx) => {
            // Only add markers for stores with valid coordinates
            if (store.lat && store.lng && !store.needsGeocoding) {
                const marker = L.marker([store.lat, store.lng], { icon: myIcon }).addTo(window.map);

                const popupContent = `
                    <div style="min-width: 200px;">
                        <h4 style="margin: 0 0 10px 0; color: #09A7DA; font-size: 16px;">${store.title}</h4>
                        <p style="margin: 0 0 10px 0; font-size: 14px;">${store.state}</p>
                        <a href="https://www.google.com/maps?q=${encodeURIComponent(store.state)}"
                           target="_blank"
                           style="color: #09A7DA; text-decoration: none; font-size: 14px;">
                            Ver no Google Maps
                        </a>
                    </div>
                `;

                marker.bindPopup(popupContent);

                // Open popup for first marker
                if (idx === 0) {
                    marker.openPopup();
                }

                window.markers.push(marker);
            }
        });

        const urlParams = new URLSearchParams(window.location.search);
        const selectedCity = urlParams.get("city");

        if (selectedCity) {
            const store = stores.find(s =>
                s.address.toLowerCase().includes(selectedCity.toLowerCase()) ||
                s.state.toLowerCase().includes(selectedCity.toLowerCase())
            );
            if (store && store.lat && store.lng) {
                window.map.setView([store.lat, store.lng], 13);

                // Abrir popup do marker correspondente
                const marker = window.markers.find(m =>
                    m.getLatLng().lat === store.lat && m.getLatLng().lng === store.lng
                );
                if (marker) marker.openPopup();

                // Focar no card correspondente
                document.querySelectorAll('[storeCard]').forEach(card => {
                    card.querySelector('.item')?.classList.remove('active');
                    const lat = parseFloat(card.getAttribute('data-lat'));
                    const lng = parseFloat(card.getAttribute('data-lng'));
                    if (lat === store.lat && lng === store.lng) {
                        card.querySelector('.item')?.classList.add('active');
                        // Opcional: rolar o card para visibilidade
                        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            }
        }

        // Calculate initial distances from map center
        calculateDistancesFromMapCenter();

        // Add event listener for map movement
        window.map.on('moveend', function() {
            calculateDistancesFromMapCenter();
        });
    }

    // Calculate distances from current map center
    function calculateDistancesFromMapCenter() {
        if (!window.map) return;

        const mapCenter = window.map.getCenter();
        const centerLat = mapCenter.lat;
        const centerLng = mapCenter.lng;

        stores.forEach(store => {
            // Only calculate distance for stores with valid coordinates
            if (store.lat && store.lng && !store.needsGeocoding) {
                const distance = calculateDistance(
                    centerLat, centerLng,
                    store.lat, store.lng
                );
                store.distance = formatDistance(distance);
            }
        });

        // Don't update display here - let the search/display functions handle it
        // This prevents overriding filtered results
    }

    // Calculate distance between two points using Haversine formula
    function calculateDistance(lat1, lng1, lat2, lng2) {
        const R = 6371; // Earth's radius in kilometers
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLng = (lng2 - lng1) * Math.PI / 180;
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                  Math.sin(dLng/2) * Math.sin(dLng/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        return R * c;
    }

    // Format distance for display
    function formatDistance(distance) {
        if (distance < 1) {
            return `${Math.round(distance * 1000)}m`;
        } else if (distance < 10) {
            return `${distance.toFixed(1)}km`;
        } else {
            return `${Math.round(distance)}km`;
        }
    }

    // Add click handlers for card interactions
    document.addEventListener('click', function(e) {
        if (e.target.closest('[storeCard]')) {
            const card = e.target.closest('[storeCard]');
            const item = card.querySelector('.item');

            // Remove active class from all cards
            document.querySelectorAll('.item').forEach(item => {
                item.classList.remove('active');
            });

            // Add active class to clicked card
            item.classList.add('active');

            // Get store data and update map
            const lat = parseFloat(card.getAttribute('data-lat'));
            const lng = parseFloat(card.getAttribute('data-lng'));

            if (window.map && !isNaN(lat) && !isNaN(lng)) {
                window.map.setView([lat, lng], 16);
            }
        }
    });
});
